import floatParser from '@shared/utils/floatParser'

export default {
    validate(value, args) {
        return floatParser(value) <= args.max
    },
    params: ['max']
}
